<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='音视频列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col v-if="rights.canAdd==1" :span="2">
          <el-button type="primary" @click="showAddDialog">添加音视频</el-button>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.group_id" placeholder="请选择栏目" filterable @change="getCategoryList">
            <el-option label="请选择栏目" :value="0"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.speaker_id" placeholder="请选择讲员" filterable @change="getCategoryList">
            <el-option label="请选择讲员" :value="0"></el-option>
            <el-option v-for="item in speakerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.category_id" placeholder="请选择专辑" filterable>
            <el-option label="请选择专辑" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-input placeholder="请输入标题" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col v-if="rights.canDownload==1" :span="2">
          <a href="/proxy/admin/download/content_list"><el-button type="primary">导出列表</el-button></a>
        </el-col>
      </el-row>
    </el-card>
   <el-table :data="contentList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="60px"></el-table-column>
      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          <a v-if="scope.row.media_url!=''" :href="scope.row.media_url" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="group_name" label="栏目" align="center"></el-table-column>
      <el-table-column prop="speaker_name" label="讲员" align="center"></el-table-column>
      <el-table-column prop="category_name" label="专辑" align="center"></el-table-column>
      <el-table-column prop="play_times" label="播放次数" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column v-if="rights.canUpdate==1 || rights.canDelete==1 || rights.canCopy==1" label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button v-if="rights.canCopy==1" type="warning" icon="el-icon-copy-document" size="mini" @click="copyRow(scope.row.id)">复制</el-button>
          <el-button v-if="rights.canUpdate==1" type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button v-if="rights.canDelete==1" type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
   <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   <content-add :visible="addDialogAvaible"
      :id="currentId"
      :groupList="groupList"
      :speakerList="speakerList"
      @add="addContent"
      @update="updateContent"
      @close="closeAddDialog">
    </content-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ContentAdd from './contentAdd.vue'
export default {
  name: 'content_list',
  components: {
    'bread-crumb': BreadCrumb,
    'content-add': ContentAdd
  },
  data () {
    return {
      groupList: [],
      speakerList: [],
      categoryList: [],
      contentList: [],
      rights: {
        canAdd: 0,
        canUpdate: 0,
        canDelete: 0,
        canDownload: 0
      },
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        group_id: 0,
        speaker_id: 0,
        category_id: 0,
        keywords: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getGroupList()
    this.getSpeakerList()
    this.getContentList()
    const rights = window.sessionStorage.getItem('rights')
    if (rights.indexOf('32') !== -1) {
      this.rights.canAdd = 1
    }
    if (rights.indexOf('33') !== -1) {
      this.rights.canUpdate = 1
    }
    if (rights.indexOf('34') !== -1) {
      this.rights.canDelete = 1
    }
    if (rights.indexOf('38') !== -1) {
      this.rights.canDownload = 1
    }
    if (rights.indexOf('60') !== -1) {
      this.rights.canCopy = 1
    }
  },
  methods: {
    async getGroupList () {
      const res = await this.$http.get('/admin/category/group/select_list')
      if (res.code === 0) {
        this.groupList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSpeakerList () {
      const res = await this.$http.get('/admin/speaker/select_list')
      if (res.code === 0) {
        this.speakerList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryList () {
      if (this.param.group_id === 0 || this.param.speaker_id === 0) {
        this.categoryList = []
        this.param.category_id = 0
        return
      }
      const res = await this.$http.get('/admin/category/select_list', {
        group_id: this.param.group_id,
        speaker_id: this.param.speaker_id
      })
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getContentList () {
      const res = await this.$http.get('/admin/content/list', this.param)
      if (res.code === 0) {
        this.contentList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getContentList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getContentList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getContentList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/content/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getContentList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    copyRow (id) {
      this.$confirm('是否真的要复制此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/content/copy/' + id)
        if (res.code === 0) {
          this.$message.success('复制成功')
          this.getContentList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addContent (data) {
      const res = await this.$http.post('/admin/content/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateContent (id, data) {
      const res = await this.$http.post('/admin/content/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getContentList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
.list_img {
  width: 50px;
}
</style>
